import { createScenario } from '@funtech-int/rival';
import { lazy } from '@funtech-int/rival-react';

import { RouteSkeleton } from '@/shared/components/PageSpinner/PageSpinner';

import { sportEventRoute, sportRoute } from './routes';

const scenario = createScenario((ctx) => {
    ctx.addRoute({
        route: sportRoute,
        meta: {
            plusPaymentPage: 'Sport',
            page: 'sport',
        },
        component: lazy(() => import('./components/MainScreen/MainScreen')),
        fallback: RouteSkeleton,
    });

    ctx.addRoute({
        route: sportEventRoute,
        meta: {
            plusPaymentPage: 'SportEvent',
            page: 'sport',
        },
        component: lazy(() => import('./components/EventScreen/EventScreen')),
        fallback: RouteSkeleton,
    });
});

export * from './routes';

export default scenario;
